module.exports = __webpack_public_path__ + "static/img/51-1.aca631f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/51-1.jpg
// module id = A8y3
// module chunks = 0